"use client";

import "@fontsource/dm-sans";
import "@fontsource/dm-mono";
import "mapbox-gl/dist/mapbox-gl.css";

import { useEffect, useState } from "react";

import "./index.css";
import App from "./App";

export default function EgoWorldClient() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setMounted(true);
    }, 0);

    return () => window.clearTimeout(timer);
  }, []);

  if (!mounted) {
    return null;
  }

  return <App />;
}
